import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { liveLanguages, aiServiceLanguages, aiServiceTranslationLanguages, srtLanguages } from './TranscriptionLanguages';

export interface ILanguageCode {
	name: string;
	code: string;
}

@Injectable({
	providedIn: 'root'
})
export class TranscriptionLanguagesService {

	public srtLanguages: ILanguageCode[] = [];
	public aiServiceLanguages: ILanguageCode[] = [];
	public aiServiceTranslationLanguages: ILanguageCode[] = [];
	public liveLanguages: ILanguageCode[] = [];

	constructor(
		private readonly translateService: TranslateService
	) {}

	public loadSrtLanguages(): ILanguageCode[] {
		if (this.srtLanguages.length === 0) {
			this.srtLanguages = this.readLanguageCodes(srtLanguages);
		}
		return this.srtLanguages;
	}

	public loadAiServiceLanguages(excludeRtls: boolean = false): ILanguageCode[] {
		if (this.aiServiceLanguages.length === 0) {
			this.aiServiceLanguages = this.readLanguageCodes(aiServiceLanguages, excludeRtls);
		}
		return this.aiServiceLanguages;
	}

	public loadAiServiceTranslationLanguages(excludeRtls: boolean = false): ILanguageCode[] {
		if (this.aiServiceTranslationLanguages.length === 0) {
			this.aiServiceTranslationLanguages = this.readLanguageCodes(aiServiceTranslationLanguages, excludeRtls);
		}
		return this.aiServiceTranslationLanguages;
	}

	public loadLiveTranscriptionLanguages(excludeRtls: boolean = false): ILanguageCode[] {
		if (this.liveLanguages.length === 0) {
			this.liveLanguages = this.readLanguageCodes(liveLanguages, excludeRtls);
		}
		return this.liveLanguages;
	}

	private readLanguageCodes(languages: Array<{ code: string, key: string, rtl?: boolean }>, excludeRtls: boolean = false): ILanguageCode[] {
		return languages
			.filter(language => !excludeRtls || language.rtl !== true)
			.map(language => ({ code: language.code, name: this.translateService.instant(language.key) }))
			.sort((a, b) => a.name.localeCompare(b.name));
	}
}
